

// interface tool{
// deepClone: Function 
// }

// let tool:tool = {
//   deepClone:function():void{}
// }

class Tool {
 public deepClone(obj:any){
    let o:any
    // 如果  他是对象object的话  , 因为null,object,array  也是'object'
    if (typeof obj === "object") {
      // 如果  他是空的话
      if (obj === null) {
        o = null
      } else {
        // 如果  他是数组arr的话
        if (obj instanceof Array) {
          o = []
          for (let i = 0, len = obj.length; i < len; i++) {
            o.push(this.deepClone(obj[i]))
          }
        }
        // 如果  他是对象object的话
        else {
          o = {}
          for (const j in obj) {
            o[j] = this.deepClone(obj[j])
          }
        }
      }
    } else {
      o = obj
    }
    return o
  }
}

// 定义一个深拷贝函数  接收目标target参数
// tool.deepClone = function (obj:any) {
//   let o
//   // 如果  他是对象object的话  , 因为null,object,array  也是'object'
//   if (typeof obj === "object") {
//     // 如果  他是空的话
//     if (obj === null) {
//       o = null
//     } else {
//       // 如果  他是数组arr的话
//       if (obj instanceof Array) {
//         o = []
//         for (let i = 0, len = obj.length; i < len; i++) {
//           o.push(tool.deepClone(obj[i]))
//         }
//       }
//       // 如果  他是对象object的话
//       else {
//         o = {}
//         for (let j in obj) {
//           o[j] = tool.deepClone(obj[j])
//         }
//       }
//     }
//   } else {
//     o = obj
//   }
//   return o
// }

export default new Tool()
